
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 198.43 198.43","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M169.1 119.81c1.72 0 3.28-.54 4.67-1.61 1.39-1.07 2.3-2.57 2.73-4.51l15.14-66.98c.64-2.36.21-4.51-1.29-6.43-1.51-1.93-3.54-2.9-6.12-2.9H57.7L54.8 22.9c-.43-1.72-1.34-3.17-2.74-4.35-1.4-1.18-2.95-1.78-4.67-1.78H14.23c-2.15 0-3.97.76-5.47 2.26-1.51 1.5-2.26 3.33-2.26 5.48v5.15c0 2.15.75 3.97 2.26 5.48 1.5 1.5 3.32 2.25 5.47 2.25h22.54l22.54 110.44c-2.79 1.72-5.04 4.08-6.76 7.09-1.72 3-2.47 6.22-2.26 9.66.22 4.51 1.99 8.42 5.32 11.75 3.32 3.32 7.24 5.1 11.75 5.31 5.15.21 9.61-1.45 13.36-5 3.76-3.54 5.64-7.88 5.64-13.04 0-5.15-1.83-9.44-5.48-12.88h67.61c-3.86 3.65-5.69 8-5.47 13.05.21 5.04 2.04 9.28 5.47 12.71 3.43 3.43 7.62 5.15 12.56 5.15s9.18-1.78 12.72-5.31c3.54-3.54 5.31-7.78 5.31-12.72 0-3.43-.92-6.6-2.74-9.49-1.82-2.9-4.35-5.1-7.57-6.61l1.93-8.04c.43-2.37-.11-4.51-1.61-6.44-1.5-1.93-3.43-2.9-5.79-2.9H76.69l-1.93-10.3 94.34-.01z","fill":"#b4343e"}})])
          )
        }
      }
    